import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {UserService} from '../services/user.service';

export const CanAccess: CanActivateFn = async (route, state) => {
	const userService = inject(UserService);
	const router = inject(Router);
	const isUserConnected = await userService.isUserConnected();
	if (!isUserConnected) {
		await router.navigate(['/login']);
		return false;
	}
	const userConnected = await userService.getStoredUserConnected();
	if (state.url?.includes('/indicateurs')) {
		return userConnected?.isAuthorized('Indicateurs', 'Visualiser');
	}
	return true;
};
